import { DataTableV2Component } from './index';
import { dataTableTemplate } from '../DataTable/DataTable';
import styles from '../DataTable//DataTable.styles.scss';
import { withStylePrefix } from '../common/withStylePrefix';
const dataTableDefinition = {
    baseName: 'data-table-v2',
    styles: withStylePrefix(styles),
    template: dataTableTemplate,
};
export const chameleonDataTableV2 = DataTableV2Component.compose(dataTableDefinition);
